import { useContext } from "react";
import { PlanContext } from "../PlanForm";
import IncOdooOrdersView from "./IncOdooOrdersView";

const IncOdooView = () => {
  const { originalPlan } = useContext(PlanContext);

  return (
    <div className="card">
      <h5 className="text-purple-600">Inc Odoo</h5>
      <div className="mt-2 opacity-70">
        WIS auto create or update Purchase Order Odoo once the plan passes
        `Sales Confirmed` stage.
      </div>

      <div className="mt-2">
        {originalPlan.parent ? (
          <div className="opacity-70">
            This is an additional plan, you can sync the updated plan to Odoo
            from the original plan.
          </div>
        ) : (
          <IncOdooOrdersView planId={originalPlan.id} />
        )}
      </div>
    </div>
  );
};

export default IncOdooView;
